import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import useContentProtection from './hooks/useContentProtection';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Certificates } from "./components/Certificates";
import { Footer } from "./components/Footer";

function App() {
  useContentProtection({
    disableRightClick: true,
    disableImageDrag: true,
    disableKeyboardShortcuts: true,
    disableTextSelection: false,
    addImageOverlay: true,
  });

  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <Certificates />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;